import React from 'react';
import {
    Card as CardComponent,
    CardProps as CardPropsLib
} from '@nesto/design-system';

export type CardProps = CardPropsLib;

export const Card = ({ ...props }: CardProps) => <CardComponent {...props} />;
